// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3cWr-","row":"ProcedureTreatmentSummary_row__2Pup6"};